export default class Suku3dNotify extends HTMLElement {
  static get observedAttributes() {
    return ['show', 'product', 'variant', 'submitting']
  }

  constructor() {
    super()

    this.submitting = false
    this.success = false

    this.className = 'hidden py-4 block'

    this.toggle.bind(this)
    this.updateSubmit.bind(this)
  }

  toggle(element, state) {
    if (state) {
      element.classList.remove('hidden')  
    } else {
      element.classList.add('hidden')
    }
  }

  updateSubmit() {
    if (this.submitting) {
      this.button.setAttribute('disabled', true)
    } else {
      this.button.removeAttribute('disabled')
    }
  }

  async handleForm(evt) {
    evt.preventDefault()

    this.setAttribute('submitting', true)

    const formdata = new FormData(this.form)

    const url = this.form.action

    const opts = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(Object.fromEntries(formdata))
    }

    const response = await fetch(url, opts)

    const data = await response.json()

    if (data === null) {
      this.setAttribute('success', true)
      this.form.classList.add('hidden')
      this.querySelector('div[data-notification-success]').classList.remove('hidden')
    }
  }

  connectedCallback() {
    this.show = this.getAttribute('show') === 'true' ? true : false
    this.available = this.getAttribute('available') === 'true' ? true : false
    this.variantId = this.getAttribute('variant-id')

    const form = document.createElement('form')
    form.setAttribute('action', 'https://formkeep.com/f/67a5eef509a0')
    form.setAttribute('method', 'POST')
    form.setAttribute('enctype', 'multipart/form-data')

    const product = document.createElement('input')
    product.setAttribute('type', 'hidden')
    product.setAttribute('name', 'product')
    product.setAttribute('value', '')

    const type = document.createElement('input')
    type.setAttribute('type', 'hidden')
    type.setAttribute('name', 'type')
    type.setAttribute('value', '3D Bed Enquiry')
    
    const variant = document.createElement('input')
    variant.setAttribute('type', 'hidden')
    variant.setAttribute('name', 'variant')
    variant.setAttribute('value', '')

    const label = document.createElement('label')
    label.setAttribute('for', 'notify_email')
    label.className = 'font-normal mobile:text-sm'
    label.textContent = 'Notify me when back in stock'

    const container = document.createElement('div')
    container.className = 'flex items-start'
    
    const email = document.createElement('input')
    email.setAttribute('type', 'email')
    email.setAttribute('name', 'email')
    email.setAttribute('value', '')
    email.setAttribute('id', 'notify_email')
    email.setAttribute('placeholder', 'Email address')
    email.className = 'border border-black grow mb-0 min-h-[44px]'

    const button = document.createElement('button')
    button.setAttribute('type', 'submit')
    button.setAttribute('name', 'add')
    button.className = 'appearance-none w-max min-w-[150px] max-w-[300px] min-h-[44px] py-2 ml-[-2px] bg-white text-black hover:bg-black hover:text-white font-normal'
    button.textContent = 'Submit'

    container.appendChild(email)
    container.appendChild(button)

    form.appendChild(product)
    form.appendChild(type)
    form.appendChild(variant)
    form.appendChild(label)
    form.appendChild(container)

    this.form = form
    this.product = product
    this.type = type
    this.variant = variant
    this.button = button

    this.appendChild(form)

    this.form.addEventListener('submit', this.handleForm.bind(this))
  }

  disconnectedCallback() {
    window.clearInterval(this.interval)
  }

  attributeChangedCallback(name, current, value) {
    if (current === value) {
      return
    }

    switch (name) {
      case 'show' :
        this.show = value === 'true' ? true : false

        this.toggle(this, this.show)
        break
      case 'available' :
        this.available = value === 'true' ? true : false

        if (this.button) {
          if (this.available) {
            this.button.removeAttribute('disabled')
          } else {
            this.button.setAttribute('disabled', true)
          }
        }

        break
      case 'product' :
        if (this.product) {
          this.product.value = value
        }

        break
      case 'variant' :
        if (this.variant) {
          this.variant.value = value
        }

        break
    }
  }
}

customElements.define('suku-3d-notify', Suku3dNotify)
